<template>
  <div>
    <v-img
      alt="bodega storefront"
      class="storefront-image"
      :class="styles.border"
      :height="styles.size"
      :width="styles.size"
      :src="wait(storeInfo, 'image')"
    ></v-img>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { wait } from "@/util.js";

const styles = {
  carousel: {
    border: "large-border",
    size: 120,
  },
  large: {
    border: "large-border",
    size: 150,
  },
  nav: {
    border: "",
    size: 60,
  },
  small: {
    border: "small-border",
    size: 100,
  },
  xs: {
    border: "",
    size: 50,
  },
};

export default {
  name: "StorefrontImage",
  computed: {
    ...mapState({
      storeInfo: (state) => state.store.info,
    }),
  },
  data() {
    return {
      styles: styles[this.size],
    };
  },
  methods: {
    wait,
  },
  props: { size: String },
};
</script>
<style scoped>
.large-border {
  border: 4px solid #ffffff;
}

.small-border {
  border: 2px solid #ffffff;
}

.storefront-image {
  background-color: #000000;
  border-radius: 50%;
}
</style>
